class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="surf-search"]');
    this.resultsContainer = this.querySelector('.predictive-search__search-results');
    this.form = this.querySelector('form');

    if (this.input) {
      this.input.addEventListener('input', this.debounce(this.handleInput.bind(this), 300));
    }

    if (this.form) {
      this.form.addEventListener('submit', (e) => e.preventDefault());
    }
  }

  debounce(fn, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  async handleInput() {
    const query = this.input.value.trim();

    if (query.length < 2) {
      this.resultsContainer.innerHTML = '';
      return;
    }

    try {
      const response = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=20&resources[options][fields]=title,product_type,variants.title,vendor,tag`
      );

      const data = await response.json();
      const products = data?.resources?.results?.products || [];

      this.renderResults(products, query);
    } catch (err) {
      console.error('Search error:', err);
    }
  }

  renderResults(products, query) {
    this.resultsContainer.innerHTML = '';

    if (products.length === 0) {
      const noResults = window.translations?.no_search_results || 'No results found.';
      this.resultsContainer.innerHTML = `<p class="search-results__no-results">${noResults}</p>`;
      return;
    }

    products.forEach((product) => {
      const html = this.buildProductHTML(product);
      this.resultsContainer.insertAdjacentHTML('beforeend', html);
    });
  }

  buildProductHTML(product) {
    // Handle "Product Name | Color" title format
    let title = product.title || '';
    let variant = '';
    if (title.includes(' | ')) {
      variant = title.split(' | ')[1];
      title = title.split(' | ')[0];
    }

    // Image
    let imageUrl = product.featured_image?.url || '';
    if (imageUrl.includes('120x120')) {
      imageUrl = imageUrl.replace('120x120', '300x300');
    }

    // Price
    let price = '';
    if (product.price) {
      const amount = (product.price / 100).toFixed(2).replace('.00', '');
      const moneyFormat = window.product?.money_format || '${{amount}}';
      price = moneyFormat.replace('{{amount}}', amount).replace('{{amount_no_decimals}}', Math.floor(product.price / 100));
    }

    // URL
    const url = product.url || '';

    return `
      <a href="${url}" class="rapid-search-product">
        <div class="rapid-search-product__image-holder">
          ${imageUrl ? `<img src="${imageUrl}" alt="${title}">` : ''}
        </div>
        <!-- end .rapid-search-product__image-holder -->

        <div class="rapid-search-product__text-holder">
          <h4 class="text-holder__title">${title}</h4>
          <!-- end .text-holder__title -->

          ${variant ? `
            <h4 class="text-holder__variant">${variant}</h4>
            <!-- end .text-holder__variant -->
          ` : ''}

          <div class="text-holder__price-holder">
            <p class="price">${price}</p>
          </div>
          <!-- end .text-holder__price -->

        </div>
        <!-- end .rapid-search-product__text-holder -->

      </a>
      <!-- end .rapid-search-product -->
    `;
  }
}

customElements.define('predictive-search', PredictiveSearch);